import { FatalAttraction as FA } from '@vpr/tracking';

import styles from './ArrowButton.module.scss';

const ArrowButton = ({ disable, facing, isMobile, onClick, tooltipText }) => {
  const isFacingLeft = facing === 'left';
  const disabledClassName = disable ? styles.disabled : '';

  const className = isFacingLeft
    ? `${styles.leftArrow} ${disabledClassName}`
    : `${styles.rightArrow} ${disabledClassName}`;

  return (
    <span
      className={`${isMobile || disable ? '' : styles.playlistTooltip}`}
      data-tooltip-text={tooltipText}
    >
      <span
        className={className}
        onClick={() => {
          onClick();
          FA.trackClick({
            container: 'embedded_playlist',
            component: isFacingLeft ? 'previous_video' : 'next_video',
          });
        }}
      >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          {isFacingLeft ? (
            <path d="m15 4-8 5.3v-5.3h-2v12h2v-5.3l8 5.3z" fill="#fff" />
          ) : (
            <path d="m13 4v5.3l-8-5.3v12l8-5.3v5.3h2v-12z" fill="#fff" />
          )}
        </svg>
      </span>
    </span>
  );
};

export default ArrowButton;
